module.exports = " <div class=users-fieldtype> <relate-fieldtype :data.sync=data :name=name :config=config v-if=config.type></relate-fieldtype> </div> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/statamic/resources/js/components/fieldtypes/UsersFieldtype.vue
// module id = 792
// module chunks = 0